// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface LearningRequestChangeStatus
 */
export interface LearningRequestChangeStatus {
    /**
     * 
     * @type {string}
     * @memberof LearningRequestChangeStatus
     */
    status: LearningRequestChangeStatusStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof LearningRequestChangeStatus
     */
    handle?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum LearningRequestChangeStatusStatusEnum {
    NotProcessed = 'not_processed',
    WaitingPayment = 'waiting_payment',
    Learning = 'learning',
    LearningFinished = 'learning_finished',
    DocumentsReady = 'documents_ready',
    Completed = 'completed',
    Cancelled = 'cancelled'
}



